<template>
   <main>
      <section class="text-center py-5">
         <div class="container py-2">
            <h3 class="text-underlined">404</h3>
            <h2 class="h1">Pagina non trovata</h2>
            <p>ci dispiace dell'inconveniente riprova più tardi</p>
            <a class="btn btn-default py-3" href="/">Torna alla homepage</a>
         </div>
      </section>
   </main>
</template>
<script>
   export default {
     name: "NotFound",
     title: '404 Pagina non trovata',
   };
</script>
<style scoped>
main{ min-height:600px; font-size:1.5rem; background:url('/img/404.jpg') center center no-repeat; background-size:contain; background-color:#003557;}
section{ background: rgba(255,255,255, 0.6); position:absolute; top:33%; width:100%; vertical-align: center}
h1{ font-size:2.5rem;}
h3{ font-size:2rem; text-decoration: underline;}

</style>